export default __webpack_public_path__ + "static/media/structure_01.ae2e9582.png";